// Brand kit assets (a logo on every scene) always sit on the top layer. Layer
// order IS the order of a scene's `.boxes` (later = in front) for the editor
// canvas, the Visor and every export, so the rule is kept in the data: whenever
// a scene's box list changes, its brand boxes move to the end. Scenes whose
// list did not change are left alone, and nothing is rebuilt when the brand
// boxes are already last.

import { isBrandBoxId } from "../common/brand_box_id";

function brandBoxesLast(boxes) {
  if (!Array.isArray(boxes) || boxes.length < 2) return boxes;
  const brand = boxes.filter(isBrandBoxId);
  if (!brand.length) return boxes;
  const tail = boxes.slice(boxes.length - brand.length);
  if (tail.every(isBrandBoxId)) return boxes;
  return boxes.filter((id) => !isBrandBoxId(id)).concat(brand);
}

function reorderChanged(byId, prevById) {
  if (!byId || byId === prevById) return byId;
  let out = byId;
  Object.keys(byId).forEach((id) => {
    const view = byId[id];
    if (!view || (prevById && prevById[id] === view)) return;
    const boxes = brandBoxesLast(view.boxes);
    if (boxes === view.boxes) return;
    if (out === byId) out = { ...byId };
    out[id] = { ...view, boxes };
  });
  return out;
}

export function keepBrandAssetsOnTop(next, prev) {
  if (!next) return next;
  const navItemsById = reorderChanged(next.navItemsById, prev && prev.navItemsById);
  const containedViewsById = reorderChanged(
    next.containedViewsById,
    prev && prev.containedViewsById
  );
  if (navItemsById === next.navItemsById && containedViewsById === next.containedViewsById) {
    return next;
  }
  return { ...next, navItemsById, containedViewsById };
}
